﻿import { events } from "@grindex-common/helpers/events";
import TabNames from "@grindex-client/components/Tabs/TabNames.class";
import asyncModule from "@grindex-client/components/Module/asyncModule";
import { apiConfig } from "@grindex-common/helpers/apiConfig";
import DocumentsApiBase from "./DocumentsApi.class";

(function listenForEvent() {
	asyncModule("nativeDocuments", events.tabLoadedEvent(new TabNames().product.documentation), init);
})();

function init($module) {
	const salesCode = $module.dataset.apiQuery;
	const culture = apiConfig.culture;
	const apiUrl = `/${apiConfig.apiLanguage}/api/nativedocuments/getdocuments/?productId=${salesCode}&culture=${culture}`;
	const documentLoader = new DocumentsApiBase($module, apiUrl);

	documentLoader.run();
}

export default {
	view: "nativeDocuments",
	init,
};
